export const ROUTES = {
  HOME: "/",
  LOGIN: "/dang-nhap",
  REGISTER: "/dang-ky",
  FORGOT_PASSWORD: "/quen-mat-khau",
  PRODUCTS: "/san-pham",
  PRODUCT_DETAIL: "/san-pham/:productId",
  GOLD_PRICE: "/gia-vang",
  NEWS: "/tin-tuc",
  NEWS_DETAIL: "/tin-tuc/:slug",
  POLICY_DETAIL: "/chinh-sach/:slug",
  COLLECTION_DETAIL: "/:collectionSlug",
  CHECKOUT: "/thanh-toan",
  CHECKOUT_TRANSFER: "/thanh-toan/chuyen-khoan/:orderId",
  ACCOUNT_PROFILE: "/ca-nhan",
  ACCOUNT_ADDRESSES: "/ca-nhan/so-dia-chi",
  ACCOUNT_ORDERS: "/ca-nhan/don-hang",
  ACCOUNT_ORDER_DETAIL: "/ca-nhan/don-hang/:orderId",
  ACCOUNT_SECURITY: "/ca-nhan/bao-mat",
  SOCIAL_CALLBACK: "/auth/social-callback",
} as const;

export const buildProductDetailPath = (productId: string) =>
  `${ROUTES.PRODUCTS}/${productId}`;

export const buildCollectionPath = (collectionSlug: string) =>
  `/${collectionSlug}`;

export const buildNewsDetailPath = (slug: string) => `/tin-tuc/${slug}`;

export const buildPolicyPath = (slug: string) => `/chinh-sach/${slug}`;

export const buildAccountAddressesPath = () => ROUTES.ACCOUNT_ADDRESSES;

export const buildCheckoutTransferPath = (orderId: string) =>
  `/thanh-toan/chuyen-khoan/${encodeURIComponent(orderId)}`;

export const buildAccountOrderDetailPath = (orderId: string) =>
  `${ROUTES.ACCOUNT_ORDERS}/${orderId}`;
